import { env } from 'next-runtime-env';

import type { Tenant } from '@core/Entities/App/Tenants.entity';

const missingContentWarnings = new Set<string>();

// Kentico is being decommissioned in favour of Umbraco. This is a hollowed-out shell —
// it no longer calls the real Kentico API — retained only so the identifiers it was
// fetching aren't lost for when its callers are migrated off Kentico.
export const getKenticoContent = async <T extends Record<string, any>>(
  identifier: string,
  depthParameter = 1,
  tenant?: Tenant,
  isContentType = false,
): Promise<T | T[] | null> => {
  const codename = tenant ? `${tenant}_${identifier}` : identifier;

  if (env('NEXT_PUBLIC_APP_ENV') === 'local') {
    const warning = `Missing Kentico ${isContentType ? 'type' : 'page'}=${codename} depthParameter=${depthParameter} locale=uk`;

    if (!missingContentWarnings.has(warning)) {
      missingContentWarnings.add(warning);
      console.warn(warning);
    }
  }

  return null;
};
